export const isValidLink = (text) => {
  const urlRegexValidator = new RegExp(
    /^(http(s):\/\/.)[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)$/g
  );
  if (urlRegexValidator.test(text)) {
    return true;
  }
  return false;
};
